export var NavigationMenuGroupStringsForDocs = function () {
    return {
        /** String to display in the overflow label */
        'navigationMenuGroup.overflowMenu.label': 'More',
    };
};
export var NavigationMenuGroupStrings = NavigationMenuGroupStringsForDocs();
